// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router';

import BusySpinner from './../../components/BusySpinner';

import './authorize.module.scss';

export default function Authorize(props: any) {
    const { t } = useTranslation();
    const userInfo = useSelector((state: any) => state.userInfo);
    const { from } = props.location.state || { from: { pathname: '/' } };
    if (userInfo.loading) {
        return (<BusySpinner messageKey={t('authorizing_loading')} />);
    }
    return userInfo.isValid ? <Redirect to={from} /> : <Redirect to="/unauthorized" />;
}

export function Unauthorize() {
    const { t } = useTranslation();
    return (
        <div className="padded">
            <h1>{t('unauthorized_error_message')}</h1>
        </div>
    );
}
